import RequestHandler from "./RequestHandler";

function ScanFiltersAPI() {
    const baseScanFiltersAPI = "scan-filters";

    async function listScanFilters(itemsPerPage = 20, offset = 0) {
        try {
            const skip = offset * itemsPerPage;
            let URL = `${baseScanFiltersAPI}?skip=${skip}&take=${itemsPerPage}`;
            const result = await RequestHandler.get(URL);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createScanFilter(newScanFilter) {
        try {
            const result = await RequestHandler.post(
                baseScanFiltersAPI,
                newScanFilter
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateScanFilter(editScanFilter) {
        try {
            const result = await RequestHandler.put(
                baseScanFiltersAPI,
                editScanFilter
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function removeScanFilter(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseScanFiltersAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        createScanFilter,
        listScanFilters,
        updateScanFilter,
        removeScanFilter,
    };
}

export default ScanFiltersAPI();
